<template>
  <div class="left_menu_container">
    <v-card theme="dark" class="settings-content" flat>
      <v-card-text class="px-0 pr-0 mr-0">
        <v-list>
          <v-list-item>
            <v-list-item-title class="client-admin-setting-section-title">
              ADMINISTRATION
            </v-list-item-title>
          </v-list-item>
          <v-expansion-panels
            v-model="panel"
            class="app-side-nav-expansion-panels"
            density="comfortable"
            variant="accordion"
            multiple
            static
            flat
          >
            <v-expansion-panel
              v-if="isAdminPanel && systemMenuItemList.length !== 0"
              id="app-side-nav-system-admin"
            >
              <v-expansion-panel-title>
                <span>
                  <v-icon>mdi-account-search</v-icon>
                  <span class="ml-3">System Administration</span>
                </span>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-list-item v-for="item in systemMenuItemList" :key="item.title" class="mb-4">
                  <router-link :to="item.link">
                    <v-list-item-title
                      :id="getLinkItemId(item.title)"
                      class="client-admin-setting-item-title"
                    >
                      {{ item.title }}
                    </v-list-item-title>
                  </router-link>
                </v-list-item>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel
              v-if="isAdminPanel && clientMenuItemList.length !== 0"
              id="app-side-nav-client-management"
            >
              <v-expansion-panel-title>
                <span>
                  <v-icon>mdi-account-cog</v-icon>
                  <span class="ml-3">Client Management</span>
                </span>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-list-item v-for="item in clientMenuItemList" :key="item.title" class="mb-4">
                  <router-link :to="item.link">
                    <v-list-item-title
                      :id="getLinkItemId(item.title)"
                      class="client-admin-setting-item-title"
                    >
                      {{ item.title }}
                    </v-list-item-title>
                  </router-link>
                </v-list-item>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel v-if="!isAdminPanel">
              <v-expansion-panel-title>
                <span>
                  <v-icon>mdi-earth-arrow-right</v-icon>
                  <span class="ml-3">Excursion Management</span>
                </span>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-list-item v-for="item in excursionMenuItemList" :key="item.title" class="mb-4">
                  <router-link :to="item.link">
                    <v-list-item-title
                      :id="getLinkItemId(item.title)"
                      class="client-admin-setting-item-title"
                    >
                      {{ item.title }}
                    </v-list-item-title>
                  </router-link>
                </v-list-item>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { mapState } from 'vuex';
import sessionManager from '@/store/modules/session/sessionManager';

export default {
  extends: CSBase,

  props: [],

  data() {
    return {
      active: 0,
      panel: []
    };
  },
  computed: {
    ...mapState({
      publicSchoolFeatureSetEnabled: (state) => state.common.publicSchoolFeatureSetEnabled,
      clientUsersTabDisplayed: (state) => state.common.clientUsersTabDisplayed,
      usersTabDisplayed: (state) => state.common.usersTabDisplayed,
      clientsTabDisplayed: (state) => state.common.clientsTabDisplayed,
      isInitClientConfigInProgress: (state) => state.authorisation.isInitClientConfigInProgress
    }),

    isAdminPanel() {
      return String(this.$route.path).includes('/admin');
    },
    clientMenuItemList() {
      const { clientSelfGroupManagementDisplayed } = this.$store.state.common;
      const { studentManagementSubjectManagementDisplayed } = this.$store.state.common;
      const riskMatrixManagementDisplayed = !this.publicSchoolFeatureSetEnabled;
      const { riskCategoryManagementMenuItemDisplayed } = this.$store.state.common;
      const { operationManagementMenuItemDisplayed } = this.$store.state.common;

      const localMenuItemList = [
        {
          title: 'Site Users',
          icon: 'person_add',
          link: '/admin/clients/users',
          menuItemDisplayEnabled: this.clientUsersTabDisplayed && this.isAdminPanel
        },
        {
          title: 'Site Settings',
          icon: 'group',
          link: '/admin/site-settings',
          menuItemDisplayEnabled: this.isAdminPanel
        },
        {
          title: 'Groups',
          icon: 'group',
          link: '/admin/group',
          menuItemDisplayEnabled: studentManagementSubjectManagementDisplayed && this.isAdminPanel
        },
        {
          title: 'Student Management',
          icon: 'group',
          link: '/admin/student-management',
          menuItemDisplayEnabled: clientSelfGroupManagementDisplayed && this.isAdminPanel
        },
        {
          title: 'Risk Matrix Management',
          icon: 'group',
          link: '/admin/risk-management',
          menuItemDisplayEnabled: riskMatrixManagementDisplayed && this.isAdminPanel
        },
        {
          title: 'Risk Category Management',
          icon: 'emergency',
          link: '/admin/risk-category-management',
          menuItemDisplayEnabled: riskCategoryManagementMenuItemDisplayed && this.isAdminPanel
        },
        {
          title: 'Operation Management',
          icon: 'emergency',
          link: '/admin/operation-management',
          menuItemDisplayEnabled: operationManagementMenuItemDisplayed && this.isAdminPanel
        }
      ];

      return localMenuItemList.filter((item) => item.menuItemDisplayEnabled);
    },
    excursionMenuItemList() {
      const localMenuItemList = [
        {
          title: 'Excursions',
          icon: 'travel_explore',
          link: '/excursions',
          menuItemDisplayEnabled: !this.isAdminPanel
        },
        {
          title: 'Excursion Templates',
          icon: 'note',
          link: '/excursions/templates',
          menuItemDisplayEnabled: !this.isAdminPanel
        }
      ];

      return localMenuItemList.filter((item) => item.menuItemDisplayEnabled);
    },
    systemMenuItemList() {
      const localMenuItemList = [
        {
          title: 'All Clients',
          icon: 'manage_accounts',
          link: '/admin/clients',
          menuItemDisplayEnabled: this.clientsTabDisplayed && this.isAdminPanel
        },
        {
          title: 'All Users',
          icon: 'person_search',
          link: '/admin/users',
          menuItemDisplayEnabled: this.usersTabDisplayed && this.isAdminPanel
        }
      ];

      return localMenuItemList.filter((item) => item.menuItemDisplayEnabled);
    }
  },
  watch: {
    $route(to) {
      if (to.name === 'ClientAdminLayout') {
        this.panel = [];
        return;
      }
      const systemAdminPages = [
        'SafeTripBuilderUsersList',
        'SafeTripBuilderClientsList',
        'SafeTripBuilderClientNewRecord',
        'SafeTripBuilderClientExistingRecord'
      ];
      if (
        !String(to.path).includes('/admin') ||
        systemAdminPages.includes(to.name) ||
        sessionManager.getClientSubdomain() !== ''
      ) {
        this.panel = [0];
        return;
      }
      this.panel = [1];
    }
  },
  methods: {
    getLinkItemId(linkItem) {
      return `client-admin-layout--menu-item--link-${linkItem}`;
    },
    pageLoadingAnimationDisplayed() {
      let loadingAnimationDisplayed = false;

      if (this.isInitClientConfigInProgress) {
        loadingAnimationDisplayed = true;
      }

      return loadingAnimationDisplayed;
    }
  }
};
</script>

<style scoped>
.app-side-nav-expansion-panels .v-expansion-panel {
  background-color: rgb(var(--v-theme-black-lighten-3)) !important;
}
:deep(.v-expansion-panel-title:hover .v-expansion-panel-title__overlay) {
  opacity: 0 !important;
}
</style>
